import { translateFunc } from "../common/Filters"
import { countriesWithTwoDigitCode } from "./Constant"

export const storeDataInStorage = (token, authlevel) => {
  localStorage.setItem("userToken", token);
  localStorage.setItem("authLevel", authlevel);

  sessionStorage.setItem("userToken", token);
  sessionStorage.setItem("authLevel", authlevel);
}

export const storeDataInSessionStorage = (token, authlevel) => {
  sessionStorage.setItem("userToken", token);
  sessionStorage.setItem("authLevel", authlevel);
}

export const storeDataInSessionStorageFromLocalStorage = () => {
  sessionStorage.setItem("userToken", localStorage.userToken);
  sessionStorage.setItem("authLevel", localStorage.authLevel);
}

export const checkLoggedinUser = () => {
  if(sessionStorage.userToken){
    return true
  } else if(localStorage.userToken){
    storeDataInSessionStorageFromLocalStorage();
    return true
  } else {
    return false
  }
}

export const checkLoggedinDealer = () => {
  if(sessionStorage.userToken && (sessionStorage.authLevel === "3" || sessionStorage.authLevel === "0")){
    return true;
  } else if( localStorage.userToken && (localStorage.authLevel === "3" || localStorage.authLevel === "0")) {
    storeDataInSessionStorageFromLocalStorage();
    return true
  } else {
    return false
  }
}

export const getTextBasedOnRoles = (user) => {
  switch (user.authlevel) {
    case "0":
      return translateFunc("lng_dealer_txt");
    case "1":
      return translateFunc("lng_user_txt");
    // case "2":
    //   return translateFunc("lng_multiuser_txt");
    case "3":
      return translateFunc("lng_admin_txt");
    default:
      return "";
  }
}

export const getCountryByPhone = (phone) => {
  let code = phone.slice(0,2);
  let index = countriesWithTwoDigitCode.findIndex(item => ("+" + code) === item.dial_code);
  return index !== -1 ? phone.slice(2, phone.length) : phone;
}

export const decodeHtml = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}